import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Material Modules
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';

// Translation
import { TranslateModule } from '@ngx-translate/core';

// Student Dashboard Table Components (shared between main app and widgets)
import { StudentFutureLessonsComponent } from '../components/student/student-dashboard/tables/student-future-lessons/student-future-lessons.component';
import { LessonStudentReportComponent } from '../components/student/student-dashboard/tables/lesson-student-report/lesson-student-report.component';
import { PaymentReportsComponent } from '../components/student/student-dashboard/tables/payment-reports/payment-reports.component';
import { NonUnitLessonsComponent } from '../components/student/student-dashboard/tables/non-unit-lessons/non-unit-lessons.component';
import { FilterResultsPanelComponent } from '../components/utility/filter-results-panel/filter-results-panel.component';

// Utility components shared by forms and widgets
import { DisplayAttendeesComponent } from '../components/utility/entity/display-attendees/display-attendees.component';
import { ScheduleConflictsComponent } from '../components/utility/schedule-conflicts/schedule-conflicts.component';
import { ErrorMessageComponent } from '../components/utility/error-message/error-message.component';

// Shared selector components
import { WeekYearSelectorComponent } from '../components/shared/week-year-selector/week-year-selector.component';
import { CalendarWeekSelectorComponent } from '../components/shared/calendar-week-selector/calendar-week-selector.component';

// Owl DateTime (needed for date range picker in week-year-selector)
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

// Pipes that might be needed
import { PhonePipe } from '../pipes/phone.pipe';
import { TruncatePipe } from '../pipes/truncate.pipe';
import { HtmlDecodePipe } from '../pipes/html-decode.pipe';
import { StudioCurrencyPipe, StudioCurrencySymbolPipe } from '../pipes/studio-currency.pipe';

/**
 * SharedModule
 *
 * Contains components, pipes, and modules that are shared between
 * the main application and widget modules.
 */
@NgModule({
  declarations: [
    // Declare shared components here
    StudentFutureLessonsComponent,
    LessonStudentReportComponent,
    PaymentReportsComponent,
    NonUnitLessonsComponent,
    FilterResultsPanelComponent,

    // Utility components
    DisplayAttendeesComponent,
    ScheduleConflictsComponent,
    ErrorMessageComponent,

    // Shared pipes
    PhonePipe,
    TruncatePipe,
    HtmlDecodePipe,
    StudioCurrencyPipe,
    StudioCurrencySymbolPipe,

    // Shared selector components
    WeekYearSelectorComponent,
    CalendarWeekSelectorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Material Modules
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule,

    // Translation
    TranslateModule,

    // Owl DateTime (for week-year-selector date range picker)
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ],
  exports: [
    // Export everything so both AppModule and WidgetModule can use them
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    // Material Modules
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatSnackBarModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatChipsModule,

    // Translation
    TranslateModule,

    // Shared components
    StudentFutureLessonsComponent,
    LessonStudentReportComponent,
    PaymentReportsComponent,
    NonUnitLessonsComponent,
    FilterResultsPanelComponent,

    // Utility components
    DisplayAttendeesComponent,
    ScheduleConflictsComponent,
    ErrorMessageComponent,

    // Shared pipes
    PhonePipe,
    TruncatePipe,
    HtmlDecodePipe,
    StudioCurrencyPipe,
    StudioCurrencySymbolPipe,

    // Shared selector components
    WeekYearSelectorComponent,
    CalendarWeekSelectorComponent,

    // Owl DateTime
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ]
})
export class SharedModule { }

